import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stockAlmostGones: [],
};

const stockAlmostGonesSlice = createSlice({
  name: "stock",
  initialState,
  reducers: {
    addStockAlmostGones: (state, action) => {
      state.stockAlmostGones = action.payload;
    },

  },
});
export const {
  addStockAlmostGones,
} = stockAlmostGonesSlice.actions;
export default stockAlmostGonesSlice.reducer;
